import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { newBorder, textPrimary, textSecondary } from "../../../utils/colors";
import { useTranslation } from "react-i18next";

const TreatmentPlanPreviewPatientNotes = ({ notes }) => {
  const { t } = useTranslation();

  return (
    <>
      <Box w={["100%", "auto"]} p={["0 1.5rem", "initial"]}>
        <Text fontSize="xs" fontWeight="500" color={textPrimary}>
          {t("treatmentPlan.tpNotesPatient")}:
        </Text>

        <Box
          w="100%"
          border={`0px solid ${newBorder}`}
          p="0.25rem 0 0"
          borderRadius="1rem"
        >
          {notes && notes.length > 0 ? (
            <Text fontSize="xs" fontWeight="500" color={textSecondary}>
              {notes}
            </Text>
          ) : (
            <Text fontSize="xs" fontWeight="500" color={textSecondary}>
              {t("treatmentPlan.tpNotesPatientEmpty")}
            </Text>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TreatmentPlanPreviewPatientNotes;
